enum QUESTION_TYPE {
  CONSENT = "CONSENT",
  WELCOME = "WELCOME",
  VIDEO = "VIDEO",
  TEXT = "TEXT",
  NUMERIC = "NUMERIC",
  SINGLE_CHOICE = "SINGLE_CHOICE",
  MULTIPLE_CHOICE = "MULTIPLE_CHOICE",
  THANKYOU = "THANKYOU",
  MESSAGE = "MESSAGE",
}
export default QUESTION_TYPE;
